<template>
  <RevContainer>
    <div class="flex flex-col items-center gap-24">
      <h2 class="text-static-default-hi heading-2">
        {{ i18n(translations.sectionTitle) }}
      </h2>
      <div class="grid grid-cols-1 gap-16 md:grid-cols-3">
        <ReassuranceCard
          v-for="card in cards"
          :key="card.title"
          :description="card.description"
          :image="card.image"
          :title="card.title"
        />
      </div>
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import ReassuranceCard from './ReassuranceCard.vue'
import translations from './SeoReassurance.translations'

const i18n = useI18n()

const cards = computed(() => [
  {
    title: i18n(translations.getOfferTitle),
    description: i18n(translations.getOfferDescription),
    image: '/img/buyback/pp/get-offer.png',
  },
  {
    title: i18n(translations.shipForFreeTitle),
    description: i18n(translations.shipForFreeDescription),
    image: '/img/buyback/pp/ship-for-free.png',
  },
  {
    title: i18n(translations.getPaidTitle),
    description: i18n(translations.getPaidDescription),
    image: '/img/buyback/pp/get-paid.png',
  },
])
</script>
